import { Button, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { InformationModal, RadioButtons } from 'utoniq-ui'

import { ArtistPreSaleLotteryApplicantDetailFragment } from '@/clients/utoniq-core/schema'
import { LotteryChoiceItem } from '@/components/organisms'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type TicketDetailsCellProps = {
  choiceItemDetails: ArtistPreSaleLotteryApplicantDetailFragment['choiceItemDetails']
  winChoiceNumber: ArtistPreSaleLotteryApplicantDetailFragment['winChoiceNumber']
  status: ArtistPreSaleLotteryApplicantDetailFragment['status']
}

export const TicketDetailsCell: Cell<TicketDetailsCellProps> = ({
  choiceItemDetails,
  winChoiceNumber,
  status,
}) => {
  const { t } = useTranslation('consoleLotteryManagementDetail')
  const [open, setOpen] = useState<boolean>(false)
  const [selected, setSelected] = useState<string>(
    (winChoiceNumber ?? '').toString()
  )

  return (
    <CellFrame>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={3}
        mt={3}
      >
        <Typography variant="h5" color="text.secondary">
          {t('appInfoHead', '応募情報')}
        </Typography>
        {/* TODO: 個別ユーザーの当落情報変更API実装後に対応 */}
        {false && (
          <Button variant="text" sx={{ mr: -2 }} onClick={() => setOpen(true)}>
            {t('changeWinLostInfo', '当落情報を変更する')}
          </Button>
        )}
      </Stack>
      <Stack spacing={5} sx={{ bgcolor: 'grey.50', p: 5, borderRadius: 2 }}>
        {choiceItemDetails.map((choiceItemDetail, index) => (
          <LotteryChoiceItem
            index={index}
            choiceLength={choiceItemDetails?.length}
            choiceItemDetail={choiceItemDetail}
            winChoiceNumber={winChoiceNumber}
            applicantStatus={status}
            hidePrice
          />
        ))}
      </Stack>
      <InformationModal
        open={open}
        onClose={() => {
          setSelected((winChoiceNumber ?? '').toString())
          setOpen(false)
        }}
        title={
          <Typography variant="h5" align="left" sx={{ pb: 3 }}>
            {status === '10_win' || status === '11_win_paid'
              ? t('changeWinTicketTitle', '当選チケットを選択してください。')
              : t(
                  'selectWinTicketTitle',
                  '当選予定に変更するチケットを選択してください。'
                )}
          </Typography>
        }
        content={
          <Stack spacing={3} sx={{ pb: 7, width: '100%' }}>
            {(status === '10_win' || status === '11_win_paid') && (
              <Typography variant="body2" align="left">
                {t('changeWinTicketDesc')}
              </Typography>
            )}
            <RadioButtons
              value={selected}
              onChange={value => {
                setSelected(value)
              }}
              sx={{
                px: 2,
                '.MuiButtonBase-root.MuiRadio-root': {
                  width: 30,
                  height: 30,
                },
              }}
              listItems={[
                {
                  value: '',
                  label: t('allScheduledToRejected', 'すべて落選予定'),
                },
              ].concat(
                Array.from(Array(choiceItemDetails?.length ?? 0).keys()).map(
                  index => ({
                    value: (index + 1).toString(),
                    label: t('choice', { number: index + 1 }),
                  })
                )
              )}
            />
          </Stack>
        }
        buttons={
          <Button size="large" sx={{ minWidth: 200 }} onClick={() => {}}>
            {t('determine', '確定する')}
          </Button>
        }
        cancelText={t('close')}
      />
    </CellFrame>
  )
}
